.shell {
	position: relative;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.scroll {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	/* keep the bounce inside this container — don't let it chain up to the
	   document and rubber-band the whole shell on iOS. */
	overscroll-behavior-y: contain;
	-webkit-overflow-scrolling: touch;
}

/* Bottom-right anchor for the active mini-app's FAB. Pinned to the shell
   (which never scrolls) so it sits just above the tab bar. Sized to its
   content; ignores pointer events so the empty slot never blocks taps on
   the scrolling content beneath it (the FAB button re-enables them). */
.fabSlot {
	position: absolute;
	right: var(--space-4);
	bottom: calc(
		var(--tab-bar-h) + var(--space-4) + env(safe-area-inset-bottom)
	);
	z-index: 90;
	pointer-events: none;
}

/* Hidden with the tab bar while the keyboard is open. */
:global(html[data-keyboard]) .fabSlot {
	display: none;
}
